/*
子系统名称  system
5G高清视频监控	hdvm
AI安全预警	   aiew
劳务人员现场实名制管理	lprn
塔机安全辅助	tcva
5G移动协作巡检	mwins
混凝土八控制	cecls
质量安全管理	qsam
5G移动数字监工 mdsu
*/
const SYSTERMNAME = {
  system: 'system',
  hdvm: 'hdvm',
  aiew: 'aiew',
  lprn: 'lprn',
  tcva: 'tcva',
  mwins: 'mwins',
  cecls: 'cecls',
  qsam: 'qsam',
  mdsu: 'mdsu'
};

const MODULESNAME = {
  logoinformation: 'logo-information',
  //5G高清视频监控
  videoinformation: 'video-information',
  snapshotinformation: 'snapshot-information',
  screeninformation: 'screen-information',
  screenshotinformation: 'screenshot-information',
  //AI安全预警
  warninformation: 'warn-information',
  //劳务人员现场实名制管理
  memberinformation: 'member-information',
  pdfinformation: 'pdf-information',
  //塔机安全辅助
  towerinformation: 'tower-information',
  //5G移动协作巡检
  inspectioninformation: 'inspection-information',
  //混凝土八控制
  stationinformation: 'station-information',
  //质量安全管理
  questioninformation: 'question-information',
  //5G移动数字监工
  digitalformation: 'digital-information'
};

export { SYSTERMNAME, MODULESNAME };
